<template>
  <v-card class="ma-0 py-2 px-4 pt-4" style="background: #F5F5F5">
    <div class="d-flex align-center mb-4">
      <h2 class="form-title">Danh sách khuyến mại</h2>
      <v-spacer />
      <v-btn icon :disabled="busy" @click="reload">
        <v-icon color="#186eac" large>mdi-reload</v-icon>
      </v-btn>
      <v-btn icon @click="close()">
        <v-icon color="red" large>mdi-close</v-icon>
      </v-btn>
    </div>
    <div>
      <div class="d-flex justify-space-bettween">
        <v-text-field
          class="search-name-km pt-0 mr-4"
          placeholder="Nhập mã khuyến mại của trung tâm hoặc của khách hàng"
          outlined
          v-model="valueSearchKM"
        />
        <v-btn style="margin: 0px;background-color: rgba(84, 127, 211);" :loading="loadingSearchKM" @click="searchListBonusByCode">kiểm tra</v-btn>
      </div>
      <div style="color: red" class="my-2"><span>{{errorMessageKM}}</span></div>
    </div>
    <div class="form-body">
      <v-row>
        <v-col v-if="isEmpty && isError" style="min-height: 470px; text-align: center; padding-top: 180px;">
          <span style="color: #787879">Lỗi hệ thống. Vui lòng thử lại sau</span>
          <br />
          <span style="color: #2f7db4; cursor: pointer;" @click="fetch">Tải lại
            <v-icon color="#2f7db4">
              mdi-reload
            </v-icon>
          </span>
        </v-col>
        <v-col v-if="isEmpty && !isError" style="min-height: 470px; text-align: center; padding-top: 180px;">
          <span v-if="busy" style="color: #787879">Đang tải...</span>
          <span v-else style="color: #787879">Hiện tại không có khuyến mại nào phù hợp. Vui lòng thử lại sau.</span>
        </v-col>
        <v-col v-if="!isEmpty" cols="7" class="pt-0" id="style-2" style="max-height: 550px; overflow-y: auto;">
          <div v-for="section in sections" :key="section.type" class="pb-4">
            <div class='d-flex justify-space-between'>
              <h3 class="mb-2">{{ section.name }}</h3>
              <div v-if='section.type == 2' style="color:#FF6609;font-size: 11px;align-self: center;font-style: italic;" class="mb-2"><v-icon style="color:#FF6609" size="small">mdi-alert</v-icon> Thứ tự chọn khuyến mại có thể ảnh hưởng đến thành tiền sau cùng</div>
              <div v-if='section.type == 3' style="color:#FF6609;font-size: 11px;align-self: center;font-style: italic;" class="mb-2"><v-icon style="color:#FF6609" size="small">mdi-alert</v-icon> Khuyến mại này không cộng dồn khi mua số lượng lớn gói Gia sư</div>
            </div>
            <div
              v-for="( item, idx ) in section.campaigns"
              :key="item._id + idx"
              class="mb-2 box-item cursor-pointer"
              :class="{'item-selected': selected && item._id == selected._id && item.promotionSubCode == selected.promotionSubCode}"
              @click="selectItem(item)"
            >
              <div class="d-flex " :style="{opacity: checkBonus(item) ? 0.5 : 1}">
                <div class="campaign-left box-detail" :style="{background:!checkBonus(item) ? section.background : 'transparent',borderRadius: checkBonus(item) ? '10px 0px 0px 0px' : '10px 0px 0px 10px'}">
                  <span class="campaign-icon">
                    <v-icon :color="!checkBonus(item) ? (section.color || '#3cb3e3') : '#333'" x-large>{{ section.icon }}</v-icon>
                  </span>
                  <div class="campaign-code">{{ item.promotionSubCode || item.promotionCode }}</div>
                </div>
                <div class="campaign-right box-detail">
                  <div style="width: 90%;">
                    <h4 class="campaign-title">{{ item.title }}</h4>
                    <div class="d-flex">
                      <div v-if="item.type == 1 || item.type == 2" :style="checkBonus(item) ? 'border: 1px solid #333; color: #333' : ''" class="campaign-sub-description mr-4">
                        <span v-if="item.promotionCampaignConditionDirect.categoryList && item.promotionCampaignConditionDirect.categoryList.length">Áp dụng cho một số danh mục cụ thể</span>
                        <span v-else>Áp dụng cho một số sản phẩm cụ thể</span>
                      </div>
                      <div v-if="item.codeIn" :style="checkBonus(item) ? 'border: 1px solid #333; color: #333' : ''" class="campaign-sub-description">Mã nhập</div>
                    </div>
                    <div  class="d-flex">
                      <div class="campaign-sub">Đơn tối thiểu: {{ formatCurrency(getMin(item))}}</div>
                      <v-spacer />
                    </div>
                    <div class="campaign-sub">Hạn dùng: {{ item.endDate ? formatDateDMY2(item.endDate) : 'Không giới hạn' }}</div>
                  </div>
                  <div style="width: 10%;">
                    <!-- <v-checkbox color="green" class="ma-0 pt-3 pb-0"></v-checkbox> -->
                    <div class="checkbox-wrapper-24" v-show="!checkBonus(item)">
                      <input type="checkbox" :id="'check-' + idx + item._id" :name="'check' + idx + item._id" v-model="item.selectedCode" @change="selectedBonus(item)" />
                      <label :for="'check-' + idx + item._id">
                        <span><!-- This span is needed to create the "checkbox" element --></span>
                      </label>
                    </div>

                    <!-- <v-radio-group  class="ma-0 pt-3 pb-0">
                      <v-radio class="ma-0 pa-0" :value="item.code" color="green" />
                    </v-radio-group> -->
                  </div>
                </div>
              </div>
              <div v-if="checkBonus(item)" class="campain-error px-4">
                <span style="color:red;font-size: 12px;"><v-icon color="red" style="font-size: 14px;">mdi-information-outline</v-icon> <span>{{item.message ? item.message : 'Không được phép áp dụng với khuyến mại đã chọn'}}</span></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col v-if="!isEmpty" cols="5" class="pt-0">
          <h3 class="mb-2">Chi tiết khuyến mại</h3>
          <div class="box-coupon-detail pa-2" id="style-2" style="height: 550px;border-radius: 10px; overflow-y: auto; overflow-x: hidden;" :style="{border: selected ? '1px solid #547fd3' : '1px solid #cccccc'}">
            <span v-if="!selected" style=" font-style: italic; color: #787879">Ấn vào khuyến mại cụ thể để xem thông tin chi tiết</span>
            <div v-else>
              <v-row>
                <v-col class="pl-6">
                  <h4>Tên chiến dịch</h4>
                  <span>{{ selected.title }}</span>
                  <h4>Mô tả</h4>
                  <span>{{ selected.description ? selected.description : '--' }}</span>
                  <h4 class="mt-2">Loại chiến dịch</h4>
                  <span style="text-transform: uppercase;">{{ selectedType }}</span>
                  <div v-if="selected.type == 1">
                    <h4 class="mt-2">Giá trị giảm</h4>
                    <span>{{ formatCurrency(selected.promotionDiscount) }}</span>
                  </div>
                  <div v-if="selected.type == 2">
                    <h4 class="mt-2">Giá trị giảm</h4>
                    <span>{{ selected.promotionDiscount }} (%)</span>
                    <h4 v-if="selected.numberOfAvailableOrder" class="mt-2">Giá trị giảm tối đa</h4>
                    <span v-if="selected.numberOfAvailableOrder">{{ formatCurrency(selected.numberOfAvailableOrder) }}</span>
                  </div>
                  <div v-if="selected.type == 1 || selected.type == 2">
                    <h4 class="mt-2">Loại hình áp dụng</h4>
                    <span>{{ application }}</span>
                  </div>
                  <h4 class="mt-2">Thời gian áp dụng</h4>
                  <span v-if="selected.endDate">{{ selected.startDate ? formatDateDMY2(selected.startDate) : '_' }} - {{ selected.endDate ? formatDateDMY2(selected.endDate) : 'Không giới hạn' }}</span>
                  <span v-else>Từ ngày {{ selected.startDate ? formatDateDMY2(selected.startDate) : '_' }}</span>
                  <h4 class="mt-2">Điều kiện áp dụng</h4>
                  <span>Giá trị đơn hàng tối thiểu: {{ formatCurrency(getMin(selected)) }}<br></span>
                  <span>Loại sản phẩm: {{ typeOfProductObj[selected.typeOfProduct] }}<br></span>
                  <div v-if="skus.length">
                    <div>Danh sách sản phẩm áp dụng:</div>
                    <ul class="pl-6">
                      <li v-for="(item, idx) in skus" :key="idx" style="list-style: disc;">
                        <div class="text-line-1">{{ item.skuName }}</div>
                      </li>
                    </ul>
                  </div>
                  <div v-if="selected.promotionCampaignConditionDirect && selected.promotionCampaignConditionDirect.categoryList && selected.promotionCampaignConditionDirect.categoryList.length">
                    <div>Danh mục được áp dụng:</div>
                    <ul class="pl-6">
                      <li v-for="(item, idx) in selected.promotionCampaignConditionDirect.categoryList" :key="idx" style="list-style: disc;">
                        <div class="text-line-1">{{ item.fullLevelName.join(" > ") }}</div>
                      </li>
                    </ul>
                  </div>
                  <div v-if="gifts.length">
                    <div>Thông tin sản phẩm tặng: </div>
                    <ul class="pl-6">
                      <li style="list-style: disc;">
                        <div><span>{{ sku.name }}.</span> <span v-if="gifts && gifts.length">{{ gifts.length === 1 ? 'Tặng' : `Tặng 1 trong ${gifts.length} sản phẩm tuỳ chọn` }}</span>:</div>                     
                        <div v-for="(item, idx) in gifts" :key="item.productCode">
                          <div class="d-flex my-2" style="align-items: flex-start;"  @click="updateGift()">
                            <v-radio-group v-model="valueGifts" @change="getValueGifts(idx)" :disabled="!!item.message" v-show="!!checked.find(check => check.code === selectedCode && check.raw.promotionSubCode === selectedpromotionSubCode)" class="ma-0 pt-0 pb-0" style="height: 32px;width:24px">
                              <v-radio class="ma-0 pa-0" :value="idx" color="green" />
                            </v-radio-group>
                            <label style="font-size: 1rem;" class="pl-3"><span style="font-weight: bold;">{{ item.quantity }}</span> x {{ item.skuName }}</label>
                          </div>
                        </div>
                      </li>
                      <li v-for="(item, oid) in otherSkus" :key="item.purchasedProductCode">
                        <span>{{ getSkuName(item.purchasedProductCode) }}</span>
                        <br />
                        Nhận:
                        <br />
                        <div v-for="(entry, gid) in item.giftProducts" :key="gid" class="d-flex">
                          <div style="width:19px;height:19px;" />
                          <label class="pl-2"><span style="font-weight: bold;">{{ entry.quantity }}</span> x {{ entry.skuName }}</label>
                        </div>
                        <div v-if="oid < otherSkus.length - 1" class="pl-2">hoặc</div>
                      </li>
                    </ul>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="d-flex pt-2 justify-end">
      <div class="d-flex mx-3">
        <span class="my-atuo" style="align-self: center;" v-if="disabled">Chưa chọn khuyến mại</span>
        <span class="my-atuo" style="align-self: center;" v-else>Đã chọn {{this.checked.length}} khuyến mại</span>
      </div>
      <v-btn clas
      mr-2 color="#b70727" width="80" @click="close()">Hủy</v-btn>
      <v-btn @click.prevent="save" color="#35b707" width="80">Áp dụng</v-btn>
    </div>
  </v-card>
</template>

<script>
import { CampaignType, getCampaignType } from '@/helpers/campaign';
import RepositoryFactory from '@/repositories/RepositoryFactory';
const OrderRepository = RepositoryFactory.get('order');

export default {
  props: {
    tutorSkus: {
      type: Array,
      default: () => []
    },
    productSelected: {
      type: Object,
      default: () => {},
    }
  },
  name: 'coupon-modal',
  data() {
    return {
      modal: false,
      sections: [],
      checked: [],
      selectedCode: undefined,
      product: null,
      sku: null,
      isError: false,
      busy: false,
      typeOfProductObj: {
        1: 'Mua mới',
        2: 'Gia hạn',
        3: 'Mua mới và Gia hạn',
      },
      loadingSearchKM: false,
      valueSearchKM: '',
      listBonusByCode: [],
      errorMessageKM: null,
      valueGifts: null,
      selectedpromotionSubCode: null,
    };
  },
  async mounted() {
    await this.open(this.productSelected)
    await this.checkBonusActive()
  },
  computed: {
    application() {
      let type = this.selected?.typeOfApplication;
      if (type == 1) return 'Theo đơn hàng';
      if (type == 2) return 'Theo sản phẩm (SKU)';
      if (type == 3) return 'Theo danh mục';
      return 'Khác';
    },
    otherSkus() {
      return [];
      const code = this.sku?.code;
      if (this.selected?.type != CampaignType.XY) return [];
      let items = this.selected.promotionCampaignConditionGiftByAmount?.giftProductsByBoughtProducts || [];
      return items.filter(it => code != it.purchasedProductCode);
    },
    disabled() {
      if (!this.checked.length) return true;
      return false;
    },
    selected() {
      if (!this.selectedCode) return null;
      for (let s of this.sections) {
        if (!Array.isArray(s.campaigns)) continue;
        for (let c of s.campaigns) {
          if (c.code == this.selectedCode && c.promotionSubCode == this.selectedpromotionSubCode) return c;
        }
      }
      return null;
    },
    selectedType() {
      if (!this.selected) return '';
      let type = getCampaignType(this.selected.type);
      return type?.name || '';
    },
    skus() {
      // if (this.selected?.type != CampaignType.DIRECT) return [];
      return this.selected.promotionCampaignConditionDirect?.skus || [];
    },
    gifts() {
      const code = this.sku?.code;
      if (this.selected?.type != CampaignType.XY) return [];
      let items = this.selected.promotionCampaignConditionGiftByAmount?.giftProductsByBoughtProducts || [];
      let item = items.find(it => it.purchasedProductCode == code);
      if (!item) return [];
      return item.giftProducts || [];
    },
    isEmpty() {
      return this.sections.length == 0;
    },
    listCacheBonusByBlock() {
      return this.$store.state.listCacheBonusByBlock;
    }
  },
  watch: {
    // 'checked.code': function() {
    //   if (this.checked.code) this.selectedCode = this.checked.code;
    //   if (this.sections.length == 0) return;
    //   this.checked.type = this.selected?.type;
    //   this.checked.raw = this.selected;
    //   this.checked.promotionSubCode = this.selected.promotionSubCode;
    //   if (this.gifts.length == 0) this.checked.giftIndex = -1;
    //   else this.checked.giftIndex = 0;
    //   let cpg = this.productSelected.campaigns?.length ? this.productSelected.campaigns[0] : {};
    //   if (this.checked.code === cpg.code) return;
    //   this.updateGift();
    // },
    // 'checked.giftIndex': function() {
    //   this.updateGift();
    // },
    valueSearchKM() {
      this.errorMessageKM = null;
    },
  },
  methods: {
    checkBonus(item) {
      if(item.message) return true
      const find = this.checked.find(data => 
        data.code !== item.code && data.raw.campaignLimitUniqueGroups.filter(tem => item.campaignLimitUniqueGroups.includes(tem)).length > 0
      );
      if (find) {
        return true
      }
      return false
    },
    getValueGifts(idx) {
      const data = this.checked.find(check => check.code === this.selectedCode && check.raw.promotionSubCode === this.selectedpromotionSubCode)
      if (data) {
        data.giftIndex = idx
        this.valueGifts = idx
        this.updateGift(data);
      }
    },
    selectedBonus(item) {
      const selectedBonusItem = {
        code: undefined,
        type: 0,
        giftIndex: -1,
        giftSelected: [],
        raw: null,
      }
      if (item.selectedCode) {
        this.selectedCode = item.code
        this.selectedpromotionSubCode = item.promotionSubCode
        selectedBonusItem.code = item.code
        selectedBonusItem.type = this.selected?.type;
        selectedBonusItem.raw = this.selected;
        selectedBonusItem.promotionSubCode = this.selected.promotionSubCode;
        if (this.gifts.length == 0) selectedBonusItem.giftIndex = -1;
        else selectedBonusItem.giftIndex = 0;
        this.valueGifts = selectedBonusItem.giftIndex
        // let cpg = this.productSelected.campaigns?.length ? this.productSelected.campaigns[0] : {};
        // if (selectedBonusItem.code === cpg.code && selectedBonusItem.promotionSubCode === this.selectedpromotionSubCode) return;
        this.checked.push(selectedBonusItem)
        this.updateGift(item);
      } else {
        this.checked = this.checked.filter(data => (data.code !== item.code) || (data.code == item.code && data.raw.promotionSubCode !== item.promotionSubCode))
      }
    },
    getSkuName(code) {
      if (this.tutorSkus?.length < 0) return '';
      let sku = this.tutorSkus.find(it => it.code == code);
      return sku?.name || '';
    },
    updateGift(item) {
      const data = this.checked.find(check => check.code === this.selectedCode && check.raw.promotionSubCode === this.selectedpromotionSubCode)
      if (data.giftIndex >= 0 && data.giftIndex < this.gifts.length) {
        data.giftSelected = [this.gifts[data.giftIndex]];
      } else {
        data.giftSelected = [];
      }
    },
    save() {
      // if (!this.checked.length) return;
      this.product.campaigns = _.cloneDeep(this.checked);
      this.$emit('save', this.product);
      this.close();
    },
    selectItem(item) {
      this.selectedCode = item.code;
      this.selectedpromotionSubCode = item.promotionSubCode
      const data = this.checked.find(check => check.code === item.code && check.raw.promotionSubCode === item.promotionSubCode)
      if (data) {
        this.valueGifts = data.giftIndex
      } 
      // if (this.selectedCode != this.checked?.code) this.checked.code = undefined;
    },
    async open(product) {
      if (!product?.productId) return;
      const skus = product.products || [];
      const sku = skus.find(item => item.id == product.productId);
      if (!sku?.code) return;
      this.product = product;
      this.sku = sku;
      this.sections = [];
      let cpg = product.campaigns?.length ? product.campaigns : [];
      cpg.forEach(element => {
        this.checked.push(
          {
            code: element.code,
            type: element.type,
            giftIndex: element.giftIndex,
            giftSelected: element.giftSelected || [],
            raw: element.raw,
          }
        )
      });
      await this.fetch();
      this.modal = true;
    },
    close() {
      this.$emit('close')
    },
    async reload() {
      if (this.busy) return;
      this.checked = [];
      await this.fetch();
      await this.checkBonusActive();
      // this.checked.forEach((element) => {
      //   if (element.message) {
      //     this.checked = this.checked.filter(data => (data.code !== element.code) || (data.code == element.code && data.raw.promotionSubCode !== element.promotionSubCode))
      //   }
      //   const find = this.sections.find(s => s.type == element.type);
      //   if (find) {
      //     const findSection = find.campaigns.find(s => s.code == element.raw.code && s.promotionSubCode == element.raw.promotionSubCode);
      //     if (!findSection) {
      //       this.checked = this.checked.filter(data => (data.code !== element.code) || (data.code == element.code && data.raw.promotionSubCode !== element.promotionSubCode))
      //     }
      //   } else {
      //     this.checked = this.checked.filter(data => (data.code !== element.code) || (data.code == element.code && data.raw.promotionSubCode !== element.promotionSubCode))
      //   }
      // });
      this.$swal({
        type: 'success',
        title: '',
        text: 'Tải lại thành công',
        toast: true,
        timer: 3000,
        showConfirmButton: false,
        icon: 'success'
      });
    },
    async fetch() {
      this.busy = true;
      this.sections = [];
      const body = {
        order: {
          totalPrice: 0,
          product: {
            skuCode: this.sku?.code,
            quantity: this.product?.count || 1,
            type: this.product.type,
            orderType: this.product?.isNew ? 1 : 2,
          }
        }
      };
      const res = await OrderRepository.getCampaigns(body);
      const sections = res?.data || [];
      this.sections = sections.map(section => {
        let type = getCampaignType(section.type) || {};
        section.campaigns.map((data) => {
          const check = this.checked.find(tem => tem.code === data.code)
          if (check) {
            data.selectedCode = true
            check.raw = data
            check.promotionSubCode = data.promotionSubCode
          } else {
            data.selectedCode = false
          }
          return data
        })
        return {
          ...section,
          ...type,
        };
      })
      .filter(s => s.type != CampaignType.GIFT)
      .filter(s => s.campaigns?.length > 0);
      this.busy = false;
      if (this.selected && this.product) {
        if (this.selected.promotionDiscount !== this.product.discount) {
          // this.checked[0].raw = this.selected;
          // this.checked[0].promotionSubCode = this.selected.promotionSubCode;
          this.product.campaigns = _.cloneDeep(this.checked);
        }
      }
    },
    async checkBonusActive() {
      if (!this.listCacheBonusByBlock.length) return;
      const body = {
        order: {
          totalPrice: 0,
          product: {
            skuCode: this.product.productCode,
            quantity: this.product.count,
            type: this.product.type,
            orderType: this.product.isNew ? 1 : 2
          }
        },
        codes: this.listCacheBonusByBlock.map((s) => { if (s.idBlock === this.product.idBlock) { return s.codeIn } }).filter(Boolean).join(','),
      }
      const res = await OrderRepository.getCampaignsByCode(body);
      if (res.data && res.data.length > 0) {
        res.data.forEach(element => {
          this.listCacheBonusByBlock.map((section) => {
            if(section.codeIn === element.code) {
              section.message = (element.message || null);
              let type = getCampaignType(section.type) || {};
              const findKM = this.sections.find((s) => s.type == section.type);
              if (findKM) {
                const findSection = findKM.campaigns.find(s => s.id == section.id && s.promotionSubCode == section.promotionSubCode);
                if (!findSection) {
                  const check = this.checked.find(tem => tem.code === section.code && tem.raw.promotionSubCode === section.promotionSubCode)
                  if (check) {
                    section.selectedCode = true
                  } else {
                    section.selectedCode = false
                  }
                  findKM.campaigns.push(section);
                } 
              } else {
                const check = this.checked.find(tem => tem.code === section.code && tem.raw.promotionSubCode === section.promotionSubCode)
                if (check) {
                  section.selectedCode = true
                } else {
                  section.selectedCode = false
                }
                this.sections.push({
                  campaigns: [section],
                  ...type,
                });
              }
            }
          });
        });
      }
    },
    getMin(c) {
      if (c.type == CampaignType.DIRECT || c.type == CampaignType.PERCENT) return c.promotionCampaignConditionDirect?.minimumAmount || 0;
      if (c.type == CampaignType.XY) return c.promotionCampaignConditionGiftByAmount?.minimumAmount || 0;
      if (c.type == CampaignType.GIFT) return c.promotionCampaignConditionGiftByProduct?.minimumAmount || 0;
      return 0;
    },
    async searchListBonusByCode() {
      if (!this.valueSearchKM.trim()) {
        this.valueSearchKM = '';
        document.querySelector('.search-name-km').classList.add('v-input--is-focused');
        document.querySelector('.search-name-km').classList.add('primary--text');
        return;
      }
      if (/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(this.valueSearchKM)) {
        this.errorMessageKM = 'Mã có định dạng không đúng';
        return;
      }
      this.loadingSearchKM = true;
      this.errorMessageKM = null;
      const body = {
        order: {
          totalPrice: 0,
          product: {
            skuCode: this.product.productCode,
            quantity: this.product.count,
            type: this.product.type,
            orderType: this.product.isNew ? 1 : 2
          }
        },
        codes: this.valueSearchKM.split(',').map(s => s.trim()).filter(Boolean).join(','),
      }
      const res = await OrderRepository.getCampaignsByCode(body)
      if(res.data && res.data.length > 0) {
        if (res.data[0] && !res.data[0].campaign) {
          this.errorMessageKM = res.data[0].message;
        } else {
          const section = {...res.data[0].campaign,codeIn: res.data[0].code};
          let type = getCampaignType(section.type) || {};
          const findKM = this.sections.find(s => s.type == section.type);
          if (findKM) {
            // check findKM.campaigns have section
            const findSection = findKM.campaigns.find(s => s.id == section.id && s.promotionSubCode == section.promotionSubCode);
            if (!findSection) {
              findKM.campaigns.push(section);
              this.$store.dispatch('SET_LIST_BONUS_BY_BLOCK',{type: 'push', object: {...section,idBlock: this.product.idBlock}})
            } 
            if (findSection) this.selectItem(section)
          } else {
            this.sections.push({
              campaigns: [section],
              ...type,
            });
            this.$store.dispatch('SET_LIST_BONUS_BY_BLOCK', {type: 'push', object: {...section,idBlock: this.product.idBlock}})
          }
        }
      }
      this.loadingSearchKM = false;
    }
  },
}
</script> 

<style lang="scss" scoped>
.gift-select {
  margin-left: -1rem;
  opacity: 1 !important;
}
.campaign-left {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 20%;
  height: 100px;
  background: #eeeeee;
  border-radius: 10px 0 0 10px;
}

.campaign-right {
  display: flex;
  align-items: center;
  padding: 0 .75rem;
  width: 80%;
  height: 100px;
  background: #fff;
  border-radius: 0 10px 10px 0;
}
.campain-error {
  padding-top: 1px;
  padding-bottom: 1px;
  background: rgba(255, 0, 0, 0.2);
  border-radius: 0 0 10px 10px;
}
.campaign-code {
  text-transform: uppercase;
  color: #595959; font-size: 10px;
}
.campaign-title {
  display: block;
  margin: 0;
  padding: 0;
  height: 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  color: inherit;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis
}
.campaign-sub {
  font-size: .875rem;
  color: #595959;
}

.form-title {
  //position: absolute;
}
.close-btn {
  position: relative;
  left: 92%;
}
.close-reset {
  position: relative;
  left: 92%;
}
.text-area-custom {
  ::-webkit-input-placeholder {
    font-style: italic;
  }
  :-moz-placeholder {
    font-style: italic;  
  }
  ::-moz-placeholder {
    font-style: italic;  
  }
  :-ms-input-placeholder {  
    font-style: italic; 
  }
}
.cursor-pointer {
  cursor: pointer;
}
.box-item {
  border: 1px solid #ccc;
  border-radius: 10px;
  &.item-selected,
  &:hover {
    border: 1px solid #547fd3;
  }
}
.display-none {
  display: none;
}
</style>